import React, { useEffect, useState } from "react";
import styles from '../styles/CommonQuestion.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Accordion from 'react-bootstrap/Accordion';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import CustomImage from "./CustomImage";
interface Props {
  data?: any;
}

const CommonQuestionsPage: React.FC<Props> = (props: any) => {
  const [selectedCategory, setSelectedCategory] = useState<any>(props.data[0])
  useEffect(() => {
    setSelectedCategory(props.data[0])
  }, [props.data])

  return (
    <div id="common-questions-page" className={styles.commonQue}>
      <Container>
        <Row>
          <h2 className="mb-5">Common Questions</h2>
        </Row>
      </Container>
      <Container>
        <Tab.Container id="left-tabs-example" defaultActiveKey={props.data[0].name.toLowerCase()}>
          <Row>
            <Col lg={4} md={4} sm={12}>
              <div className={styles.tabNav}>
                <Nav variant="pills" className={styles.navsett} >
                  {
                    props.data.map((category: any) => {
                      return (
                        <Nav.Item className={styles.navLink} key={category.id} onClick={() => setSelectedCategory(category)}>
                          <Nav.Link eventKey={category.name.toLowerCase()}
                            className={`${styles.navAnchor} ${category.name === selectedCategory.name ? styles.active : ''}`}>
                            {category.imagePath && <CustomImage src={category.imagePath} height={26} width={26} alt={"imagePath"} />}
                            <span><h3>{category.name}</h3></span>
                          </Nav.Link>
                        </Nav.Item>
                      )
                    })
                  }
                </Nav>
              </div>
            </Col>
            <Col lg={8} md={8} sm={12}>
              <div className={`${styles.tabContent} ${styles.content}`}>
                <Tab.Content>
                  <Tab.Pane eventKey={selectedCategory.name.toLowerCase()}>
                    <h3>{selectedCategory.name}</h3>
                    <Accordion>
                      {
                        selectedCategory?.questions?.length > 0 &&
                        selectedCategory?.questions.map((qna: any, index: number) => {
                          return (
                            <Accordion.Item eventKey={index.toString()} className={styles.stuAccordion} key={index}>
                              <Accordion.Header className={styles.accoHead}>{qna.question}</Accordion.Header>
                              <Accordion.Body className={styles.accorBody}>
                                {qna.answer}
                              </Accordion.Body>
                            </Accordion.Item>
                          )
                        })
                      }
                    </Accordion>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </Col>
          </Row>
        </Tab.Container>
      </Container>
    </div>
  )
}

export default CommonQuestionsPage;